/** W4–W6: a GOT dispatch's GSDN, Gate Pass Out and GRS prints (manual p117–119). */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import {
  GotPrintPage,
  type GotPrintKind,
} from "@/features/got/components/print-page";

const KINDS: GotPrintKind[] = ["gsdn", "gate-pass", "grs"];

export const Route = createFileRoute(
  "/_app/quality/got/print/$kind/$dispatchId"
)({
  beforeLoad: ({ params }) => {
    if (!useAuth.getState().can("got.dispatch")) throw redirect({ to: "/" });
    if (!KINDS.includes(params.kind as GotPrintKind))
      throw redirect({ to: "/quality/got/dispatch" });
  },
  component: Page,
});

function Page() {
  const { kind, dispatchId } = Route.useParams();
  return (
    <GotPrintPage kind={kind as GotPrintKind} dispatchId={Number(dispatchId)} />
  );
}
